import { useEffect, useReducer } from "react";
import { initialState, profileBoostReducer } from "./profileBoost.reducer";
import {
  getIdentityVerifyStatus,
  getStripePayment,
  verifyIdentity,
} from "../api/profileBoost.api";
import apiService from "../../../../services/api";

export const useProfileBoostViewModel = () => {
  const [state, dispatch] = useReducer(profileBoostReducer, initialState);

  const handleIdentityVerifyStatus = async () => {
    try {
      const response = await getIdentityVerifyStatus();
      console.log(response.data);
      dispatch({ type: "SET_IDENTITY_VERIFY_STATUS", payload: response.data });
    } catch (error) {
      console.error("Error fetching identity verify status:", error);
    }
  };
  const handleVerifyIdentity = async () => {
    try {
      const response = await verifyIdentity(
        `${window.location.origin}/candidate/profile-boost`,
      );
      const checkoutUrl = response.data?.checkout_url;
      window.location.href = checkoutUrl;
      if (checkoutUrl) {
        dispatch({ type: "SET_CHECKOUT_URL", payload: checkoutUrl });
      }
    } catch (error) {
      console.error("Error verifying identity:", error);
    }
  };
  const handleStripePayment = async () => {
    try {
      const resp = await getStripePayment(
        `${window.location.origin}/candidate/profile-boost`,
        `${window.location.origin}/candidate/profile-boost`,
      );
      const checkoutUrl = resp.data?.checkout_url;
      window.location.href = checkoutUrl;
      await handleIdentityVerifyStatus();
    } catch (error) {
      console.log("error in stripe payment", error);
    }
  };
  useEffect(() => {
    handleIdentityVerifyStatus();
  }, []);

  return {
    state,
    dispatch,
    handleIdentityVerifyStatus,
    handleVerifyIdentity,
    handleStripePayment,
  };
};
